// extracted by mini-css-extract-plugin
module.exports = {"sm":"only screen and (min-width: 768px)","mobile_close_icon":"more_info__mobile_close_icon__1i4qU position__pos_absolute__CTqRu borders__border_radius_rounded__BofJh"};